import { FC, useState, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { Search } from "@appkit4/react-components";
import { searchFilter } from "services/common";
import { ActiveFilters } from "components/layout/filters/filters";
import { Floater, ProfileItem } from "routes/analysis/helpers/analysisHelpers";
import { ProfileData } from "routes/analysis/types/user";

interface UserProfilesProps {
  userData?: {
    profiles: ProfileData[];
  };
}

const UserProfiles: FC<UserProfilesProps> = ({ userData }) => {
  const { analysisId, profileId, userId } = useParams();
  const [search, setSearch] = useState("");
  
  const data = useMemo(() => userData?.profiles || [], [userData]);
  const filteredData = useMemo(() => data.filter(f => searchFilter(f, ["name"], search)), [data, search]);

  return (
    <>
      <div className="flex items-center gap-4 mt-4">
        <div>
          <Search
            searchType={"secondary"}
            onChange={(value: string) => setSearch(value)}
            className="list-filter"
          />
        </div>
      </div>
  <ActiveFilters rows={filteredData.length} />
      <Floater>
        <div
          className="ap-list-header ap-business-process-header flex items-center p-4 pt-6 pb-6 gap-4 w-full"
        >
          <div className="basis-12"></div>
          <div className="basis-80">
            Profile name
          </div>
          <div className="basis-32">
            Profile type
          </div>
          <div className="basis-28">
            One or more matches
          </div>
        </div>
      </Floater>
  {filteredData.map(profile => (
        <div key={profile.profileId} className="list-row">
          <Link className="pointer" to={profileId === profile.profileId ? `/analysis/${analysisId}/user/${userId}/profile/` : `/analysis/${analysisId}/user/${userId}/profile/${profile.profileId}`} relative="path">
            <ProfileItem profile={profile} open={profile.profileId === profileId} />
          </Link>
          <div className="ap-accordion-open">
            {profile.profileId === profileId && profile.profiles?.map(p => (
              <div className="list-row-1" key={p.profileId}>
                <ProfileItem profile={p} open={false} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  )
}

export default UserProfiles;
